<section class="container-fluid  p-0" *ngIf="company || companies">
  <div class="bg-cover border-dark-gray" *ngIf="company?.Employer.HeaderImage"
    [style.height]="Utility.mobile? '100px' : '200px'" [style.margin-bottom]="Utility.mobile? '-40px' : '-80px'"
    [style.background-image]="'url(' + headerImage + ')'">
  </div>
  <div class="container pt-3">
    <ng-container *ngIf="company?.Employer">
      <div class="row">
        <div class="col-12">
          <div class="rounded-xl shadow-kp white-bg p-2 mb-3 d-md-flex relative">
            <div class="text-center px-3">
              <div *ngIf="company.Employer.Logo" class="p-2 mx-auto " [style.width]="Utility.mobile ? '80px' : '120px'"
                [style.height]="Utility.mobile ? '80px' : '120px'">
                <img class="mw-100 mh-100 mx-auto" [src]="logoImage" [alt]="company.Employer.Company">
              </div>
              <div class="">
                <h1 class="mb-0 h3">{{company.Employer.Company}}</h1>
              </div>
            </div>
            <div class="d-none d-md-block border-right border-dark-gray mx-2"></div>
            <div class="d-md-none border-top border-dark-gray my-2"></div>
            <div class="flex-grow-1 pr-2">
              <div class="d-md-flex">
                <div class="flex-grow-1" [class.d-none]="Utility.mobile && !showInfo">
                  <div class="d-flex py-1" *ngIf="company.Employer.Industries?.length">
                    <i class="fa fa-industry fs-lg pt-1 pl-2"></i>
                    <div class="">
                      <div *ngFor="let industry of company.Employer.Industries">{{industry}}</div>
                    </div>
                  </div>
                  <div class="d-flex py-1" *ngIf="company.Employer.State">
                    <i class="fa fa-map-marker-alt fs-lg pt-1 pl-2"></i>
                    <div>{{[company.Employer.State, company.Employer.City] | join: '،'}}</div>
                  </div>
                  <div class="d-flex py-1" *ngIf="company.Employer.CompanySize">
                    <i class="fa fa-user-friends fs-lg pt-1 pl-2"></i>
                    <div>{{company.Employer.CompanySize}} پرسنل</div>
                  </div>
                  <div class="d-flex py-1" *ngIf="company.Employer.EstablishmentYear">
                    <i class="fa fa-calendar-alt fs-lg pt-1 pl-2"></i>
                    <div>تاسیس شده در سال {{company.Employer.EstablishmentYear}}</div>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex py-1" *ngIf="company.Employer.Email">
                    <i class="fa fa-envelope fs-lg pt-1 pl-2"></i>
                    <a [href]="'mailto:' + company.Employer.Email">{{company.Employer.Email}}</a>
                  </div>
                  <div class="d-flex py-1" *ngIf="company.Employer.Phone">
                    <i class="fa fa-phone fs-lg pt-1 pl-2"></i>
                    <a [href]="'tel:'+company.Employer.Phone">{{company.Employer.Phone}}</a>
                  </div>
                  <div class="d-flex py-1" *ngIf="company.Employer.Address">
                    <i class="fa fa-building fs-lg pt-1 pl-2"></i>
                    <div>{{company.Employer.Address}}</div>
                  </div>
                  <div class="d-flex py-1" *ngIf="company.Employer.Website">
                    <i class="fa fa-link fs-lg pt-1 pl-2"></i>
                    <a [href]="(company.Employer.Website.startsWith('http') ? '' : 'http://') + company.Employer.Website"
                      target="_blank" rel="nofollow">{{company.Employer.Website}}</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="absolute left-0 pointer rounded-right-xl yellow-bg px-2"
              (click)="showInfo = !showInfo;jobList.open();" [style.bottom]="Utility.mobile? '10px' : '30px'">
              بیشتر بخوانید
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <section class="row">
      <ng-container *ngIf="company?.Employer">
        <div class="col-12 col-md-8 order-md-1" [class.d-none]="!showInfo">
          <section class="p-2 white-bg rounded-xl shadow-kp relative">
            <div class="border-bottom py-1 mb-1">
              <h5>درباره {{company.Employer.Company}}</h5>
            </div>
            <div>
              <div [innerHTML]="company.Employer.About"
                class="text-justify fs-normal long-text wrap mt-2  p-2 overflow-auto lh-lg"></div>
            </div>
          </section>
        </div>
      </ng-container>
      <div class="col px-0 order-md-0">
        <job-list [criteria]="searchParams" [loadMoreEnabled]="true" (detail)="showInfo = showInfo && !$event"
          #jobList></job-list>
      </div>
    </section>
  </div>
  <div class="pb-3">
    <app-subscribe-search  [params]="searchParams"
      [source]="'company-detail'" *ngIf="searchParams">
    </app-subscribe-search>
  </div>

</section>